// TODO: If you make edits to this file you must deal with these ESLint rules
/*eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

import styled from '@emotion/styled';

import { BREAKPOINTS, getColorTint, unit, unitTRBL } from '@zego/theme';

import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';
import FlexRow from '@zego/components/molecules/FlexRow';
import ContentContainer from '@zego/components/SCContentContainer';
import StaticImage from '@zego/components/StaticImage';

interface HighImpactSectionProps {
  children: React.ReactNode;
  imageUrl: string;
  imageAlt: string;
  imageRatio: number;
  imagePosition: 'left' | 'right';
}

export default function HighImpactSection({
  children,
  imageUrl,
  imageAlt,
  imageRatio,
  imagePosition,
  ...rest
}: HighImpactSectionProps): JSX.Element {
  const imageOnTheLeft = imagePosition === 'left';

  return (
    <View
      css={{
        padding: unitTRBL(4, 0, 4, 0),
        backgroundColor: getColorTint('grey', 1),

        [BREAKPOINTS.large]: {
          padding: unitTRBL(11, 12, 11, 12),
        },
      }}
      {...rest}
    >
      <ContentContainer>
        <FlexRowContainer
          css={{
            [BREAKPOINTS.medium]: {
              flexDirection: imageOnTheLeft ? 'row' : 'row-reverse',
              alignItems: 'center',
            },
          }}
        >
          <MainImage src={imageUrl} alt={imageAlt} ratio={imageRatio} />
          <Spacer mobileHeight={unit(2)} />
          <View
            css={{
              width: '100%',
              [BREAKPOINTS.medium]: {
                width: '50%',
              },
              [BREAKPOINTS.smallOnly]: {
                textAlign: 'center',
              },
            }}
          >
            {children}
          </View>
        </FlexRowContainer>
      </ContentContainer>
    </View>
  );
}

/**
 * Styled components
 */

const MainImage = styled(StaticImage)({
  width: '100%',
  borderRadius: unit(1),

  [BREAKPOINTS.medium]: {
    width: '42%',
  },
});

const FlexRowContainer = styled(FlexRow)({
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  flexDirection: 'column',
});
